import { memo } from "react";

// MUI
import { Divider, Stack } from "@mui/material";

function TabActionsContent(props) {
	const { actions = [], actionsProps, dividerContainerProps, dividerProps, generalProps } = props;
	return (
		<Stack {...generalProps} direction={"row"} justifyContent={"flex-end"}>
			{actions?.map((action, key) => {
				return (
					<Stack key={key} direction={"row"}>
						<Stack {...actionsProps}>{action}</Stack>
						{Boolean(actions.length - 1 !== key) && (
							<Stack alignItems={"center"} justifyContent={"center"} {...dividerContainerProps}>
								<Divider orientation={"vertical"} className="!border-disabled !h-[20px] !-mr-[15px]" {...dividerProps} />
							</Stack>
						)}
					</Stack>
				);
			})}
		</Stack>
	);
}

const TabActions = memo(TabActionsContent);
export default TabActions;
